import { trans } from '@spotahome/soyuz/client';

import {
  hoursAfterAcceptanceKeys,
  formatSimpleCancellationDate
} from '@common/utils/cancellationPolicies';

import { HOMECARD_IMAGE_SIZES } from '../constants';

export const getHomecardImageSet = photoUrls =>
  Object.keys(photoUrls)
    .filter(size => photoUrls[size] && HOMECARD_IMAGE_SIZES[size])
    .map(size => `${photoUrls[size]} ${HOMECARD_IMAGE_SIZES[size]}`)
    .join(', ');

export const getUrlWithMovingDates = (url, moveIn, moveOut) => {
  let getParams = [];
  getParams = moveIn ? [...getParams, `move-in=${moveIn}`] : getParams;
  getParams = moveOut ? [...getParams, `move-out=${moveOut}`] : getParams;

  return getParams.length ? `${url}?${getParams.join('&')}` : url;
};

export const getLabels = (noDeposit, cancellationDeadline) => {
  const labels = [];

  if (noDeposit) {
    const noDepositLabel = {
      text: `${trans('homecard.label.no_deposit')}`,
      color: 'blue-indigo',
      tooltip: `${trans('tooltip.message.no-deposit')}`
    };
    labels.push(noDepositLabel);
  }

  if (cancellationDeadline && cancellationDeadline.freeCancellationCurrently) {
    const hasHoursAfterAcceptance =
      cancellationDeadline.freeCancellationDeadlineType ===
      'hoursAfterAcceptance';

    const renderHoursAfterAcceptanceMessage = `${trans(
      `${hoursAfterAcceptanceKeys.title}`
    )} ${trans(`${hoursAfterAcceptanceKeys.afterBookingAccepted}`, {
      hour: cancellationDeadline.freeCancellationDeadlineValue
    })}`;

    const freeCancellationLabel = {
      text: `${trans('homecard.label.free_cancellation')}`,
      color: 'blue-cerulean',
      tooltip: hasHoursAfterAcceptance
        ? renderHoursAfterAcceptanceMessage
        : `${trans(
            'cancellationPolicy.free.message',
            formatSimpleCancellationDate(
              cancellationDeadline.freeCancellationDeadlineValue
            )
          )}`
    };
    labels.push(freeCancellationLabel);
  }

  return labels;
};

export const getRatingFromReviews = (reviews = {}) => reviews.ratingAverage;
